import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import client from '../api/client';
import { useAuth } from '../context/AuthContext';
import { Project } from '../types';
import './Dashboard.css';

export default function Dashboard() {
  const { user } = useAuth();
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client.get('/api/armundi/projects')
      .then(r => setProjects(Array.isArray(r.data) ? r.data : r.data.projects || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const totalModels = projects.reduce((s, p) => s + (p._count?.models || p.models?.length || 0), 0);

  return (
    <div className="dashboard">
      <div className="page-header">
        <div>
          <h1 className="page-title">Übersicht</h1>
          <p className="page-subtitle">Willkommen zurück, {user?.name}.</p>
        </div>
        <Link to="/projects/new" className="btn-primary">Neues Projekt</Link>
      </div>

      <div className="stat-row">
        <div className="stat-card">
          <span className="stat-label">Projekte</span>
          <span className="stat-value">{loading ? '—' : projects.length}</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">Modelle</span>
          <span className="stat-value">{loading ? '—' : totalModels}</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">Organisation</span>
          <span className="stat-value">{user?.organisation?.name || '—'}</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">Plan</span>
          <span className="stat-value stat-plan">{user?.organisation?.plan || '—'}</span>
        </div>
      </div>

      <div className="section-header">
        <h2 className="section-title">Zuletzt aktiv</h2>
        <Link to="/projects" className="link-all">Alle Projekte</Link>
      </div>

      {loading ? (
        <div className="loading-state">Wird geladen...</div>
      ) : projects.length === 0 ? (
        <div className="empty-state">
          <p className="empty-title">Noch keine Projekte vorhanden.</p>
          <p className="empty-sub">Erstellen Sie Ihr erstes Projekt, um Modelle hochzuladen.</p>
          <Link to="/projects/new" className="btn-primary" style={{marginTop: '16px', display:'inline-block'}}>Erstes Projekt anlegen</Link>
        </div>
      ) : (
        <div className="project-grid">
          {projects.slice(0,6).map(p => (
            <Link to={`/projects/${p.id}`} key={p.id} className="project-card">
              <div className="project-card-header">
                <span className="project-name">{p.name}</span>
                <span className="project-count">{p._count?.models ?? p.models?.length ?? 0} Modelle</span>
              </div>
              {p.description && <p className="project-desc">{p.description}</p>}
              <span className="project-date">{new Date(p.updatedAt).toLocaleDateString('de-DE')}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
